import { parseCollectionItemData } from 'api/parsers/parseCollectionItemData';
import { fetch } from 'api/typedFetch';
import { type CollectionItem } from 'api/types/CollectionItem';

export interface RawCollectionData {
  items: {
    [key: string]: {
      file_id: string;
      image: string;
      pageID: string;
      title: string;
      type: string;
      url: string;
    }[];
  };
}

export const getData = async (id: string) => {
  const response = await fetch('GET_COLLECTION', { params: new URLSearchParams({ sales_companion_item_id: id }) });
  const data = await response.json();

  return Object.entries(data.items).reduce(
    (acc, [key, value]) => {
      return {
        ...acc,
        [key]: value.map(parseCollectionItemData),
      };
    },
    {} as Record<string, CollectionItem[]>,
  );
};
